// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { readFromLocalStorage } from "./utils/DataEncryption";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        activeStaff: "Active Staff",
        ConflictingUser: "Conflicting User",
        pendingStaff: "Pending Staff",
        TotalStaff: "Total Staff",
        AddNewStaff: "Add New Staff",
        Completetheonboardingprocessfornewstaff:
          "Complete the onboarding process for new staff",
        onboardRoute: "/onboard",
        EmployeeList: "Employee List",
        Clicktonavigatetostafflist: "Click to navigate to staff list",
        staffListRoute: "/staffList",
        members: "members",
        download: "Download",
        filters: "Filters",
        sort: "Sort",
        StaffName: "Staff Name",
        Baserole: "Base Role",
        CreatedDate: "Created Date",
        UserValidation: "User Validation",
        Roles: "Roles & Applications",
        ConflictingReason: "Conflicting Reason",
        Last: "Last Used Application",
        Status: "Status",
        Actions: "Actions",
        add: "Add",
        UserReject: "REJECT USER",
        deactivateUser: "DEACTIVATE USER",
        ActivateUser: "ACTIVATE USER",
        AcceptUser: "ACCEPT",
        RejectUser: "REJECT",
        noMoreDataToShow: "No more data to show",
        rowsPerPage: "Rows per page",
        page: "Page",
        of: "of",
        Previous: "Previous",
        Next: "Next",
        overview: "Overview",
        quickLinks: "Quick Links",
        cancel: "Cancel",
        continue: "Continue",
        selectAnAction: "Select an action",
        staffExitProcess: "Staff Exit Process",
        AreYouSure: "Are you sure?",
        UserApprovedDescription: "Click the button below to proceed",
        Okay: "Okay",
        Pending: "Pending",
        Active: "Active",
        Inactive: "Inactive",
        Passive: "Passive",
        ActiveStaff: "Active Staff",
        PendingStaff: "Pending Staff",
        Welcome: "Welcome",
        SearchForAnything: "Search for anything",
        Search: "Search",
        Logout: "Logout",
        close: "Close",
        ComingSoon: "Coming Soon",
        Tutorial: "Tutorial",
        seeTutorial: "See Tutorial",
        help: "Need Help with DEM?",
        Dashboard: "Dashboard",
        Applications: "Applications",
        UserRoles: "User Roles",
        Reports: "Reports",
        Location: "Location",
        Help: "Help",
        Setting: "Setting",
        "Employee List": "Employee List",
        approveUser: "Do you want to approve theuser?",
        activateUser: "Do you want to activate the user?",
        rejectUser: "Do you want to reject the user?",
        inActivateUser: "Do you want to deactivate the user?",
        Yes: "Yes",
        No: "No",
        ApprovedSuccessMessage: "User approved sucessfully",
        RejectedSuccessMessage: "User rejected sucessfully",
        ActivatedSuccessMessage: "User activated sucessfully",
        DeactivatedSuccessMessage: "User deactivated sucessfully",
        APIErrorMessage: "Something went wrong....Pls try again",
        ConflictApproveConfimationMessage:
          "Do you want to approve the user to move to other dealership?",
        ConflictRejectConfimationMessage:
          "Do you want to reject this user to stay in your dealership?",
        RejectConfirmationMessage: "Do you want to reject this user?",
        ConflictStaffList: "Conflict Staff",
        staffExitSuccessMessage1: "User Offboarding Successfull",
        staffExitSuccessMessage2:
          "All necessary fields have been filled, and access has been revoked.",
        staffExitFlowTitle: "Staff Exit Process",
        staffInformationDescription:
          "Fill in all the necessary fields to offboard the user.",
        AccountCreatedOn: " Account Created on :",
        Id: "Employee ID :",
        lastWorkingDay: "Last Working Day",
        selectTheLastWorkingDay: "Enter or select the last working day",
        selectReasonForExit: "Select the reason for exit",
        reasonForExit: "Reason for exit",
        additionalComments: "Additional comments",
        otherReason: "Enter other reason",
        additionalCommentErrorMessage: "Please enter the additional comments",
        confirmAndSubmit: "Confirm and Submit",
        latestEmployeeList: "Latest 10 employee list",
        UID: "U ID : ",
      },
    },
    es: {
      translation: {
        activeStaff: "Personal Activo",
        ConflictingUser: "Usuario en Conflicto",
        pendingStaff: "Personal Pendiente",
        TotalStaff: "Personal Total",
        AddNewStaff: "Agregar Nuevo Personal",
        Completetheonboardingprocessfornewstaff:
          "Completa el proceso de incorporación para nuevo personal",
        onboardRoute: "/onboard",
        EmployeeList: "Lista de Empleados",
        Clicktonavigatetostafflist: "Haz clic para ir a la lista de personal",
        staffListRoute: "/staffList",
        members: "miembros",
        download: "Descargar",
        filters: "Filtros",
        sort: "Ordenar",
        StaffName: "Nombre del Personal",
        Baserole: "Rol Base",
        CreatedDate: "Fecha de Creación",
        UserValidation: "Validación del Usuario",
        Roles: "Roles y Aplicaciones",
        ConflictingReason: "Motivo del Conflicto",
        Last: "Última Aplicación Usada",
        Status: "Estado",
        Actions: "Acciones",
        add: "Agregar",
        UserReject: "RECHAZAR USUARIO",
        deactivateUser: "DESACTIVAR USUARIO",
        ActivateUser: "ACTIVAR USUARIO",
        AcceptUser: "ACEPTAR",
        RejectUser: "RECHAZAR",
        noMoreDataToShow: "No hay más datos para mostrar",
        rowsPerPage: "Filas por página",
        page: "Página",
        of: "de",
        Previous: "Anterior",
        Next: "Siguiente",
        overview: "Resumen",
        quickLinks: "Enlaces Rápidos",
        cancel: "Cancelar",
        continue: "Continuar",
        selectAnAction: "Selecciona una acción",
        staffExitProcess: "Proceso de Salida del Personal",
        AreYouSure: "¿Estás seguro?",
        UserApprovedDescription: "Haz clic en el botón de abajo para continuar",
        Okay: "Aceptar",
        Pending: "Pendiente",
        Active: "Activo",
        Inactive: "Inactivo",
        Passive: "Pasivo",
        ActiveStaff: "Personal Activo",
        PendingStaff: "Personal Pendiente",
        Welcome: "Bienvenido",
        SearchForAnything: "Buscar cualquier cosa",
        Search: "Buscar",
        Logout: "Cerrar sesión",
        close: "Cerrar",
        ComingSoon: "Próximamente",
        Tutorial: "Tutorial",
        seeTutorial: "Ver Tutorial",
        help: "¿Necesitas ayuda con DEM?",
        Dashboard: "Tablero",
        Applications: "Aplicaciones",
        "User Roles": "Roles de Usuario",
        Reports: "Informes",
        Location: "Ubicación",
        Help: "Ayuda",
        Setting: "Configuración",
        "Employee List": "Lista de Empleados",
        approveUser: "¿Quieres aprobar al usuario?",
        activateUser: "¿Quieres activar al usuario?",
        rejectUser: "¿Quieres rechazar al usuario?",
        inActivateUser: "¿Quieres desactivar al usuario?",
        Yes: "Sí",
        No: "No",
        ApprovedSuccessMessage: "Usuario aprobado correctamente",
        RejectedSuccessMessage: "Usuario rechazado correctamente",
        ActivatedSuccessMessage: "Usuario activado correctamente",
        DeactivatedSuccessMessage: "Usuario desactivado correctamente",
        APIErrorMessage: "Algo salió mal... Por favor, inténtalo de nuevo",
        ConflictApproveConfimationMessage:
          "¿Quieres aprobar al usuario para que se traslade a otro concesionario?",
        ConflictRejectConfimationMessage:
          "¿Quieres rechazar a este usuario para que permanezca en tu concesionario?",
        RejectConfirmationMessage: "¿Quieres rechazar a este usuario?",
        ConflictStaffList: "Personal en Conflicto",
        staffExitSuccessMessage1: "Offboarding de usuario exitoso",
        staffExitSuccessMessage2:
          "Todos los campos necesarios han sido completados y el acceso ha sido revocado.",
        staffExitFlowTitle: "Proceso de Salida de Personal",
        staffInformationDescription:
          "Complete todos los campos necesarios para dar de baja al usuario.",
        AccountCreatedOn: "Cuenta creada el : ",
        Id: "ID de empleado : ",
        lastWorkingDay: "Último día laboral",
        selectTheLastWorkingDay: "Ingrese o seleccione el último día laboral",
        selectReasonForExit: "Seleccione la razón de la salida",
        reasonForExit: "Razón de la salida",
        additionalComments: "Comentarios adicionales",
        otherReason: "Ingrese otra razón",
        additionalCommentErrorMessage:
          "Por favor ingrese los comentarios adicionales",
        confirmAndSubmit: "Confirmar y enviar",
        latestEmployeeList: "Lista de los últimos 10 empleados",
      },
    },
  },
  lng: readFromLocalStorage("langCode"),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
